import React from "react";
import { Globe, MessageSquare, BarChart3, FileText } from "lucide-react";

const FooterMobile = ({ activeView, setActiveView }) => {
  return (
    <div className="static bottom-0 left-0 right-0 w-screen bg-slate-800 p-2 pb-safe-bottom border-t border-slate-700 flex-shrink-0">
      <div className="flex justify-around">
        <button
          onClick={() => setActiveView('map')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${activeView === 'map'
            ? 'bg-cyan-600 text-white'
            : 'text-slate-400 hover:text-white'
            }`}
        >
          <Globe size={20} />
          <span className="text-xs mt-1">Carte</span>
        </button>
        <button
          onClick={() => setActiveView('chat')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${activeView === 'chat'
            ? 'bg-cyan-600 text-white'
            : 'text-slate-400 hover:text-white'
            }`}
        >
          <MessageSquare size={20} />
          <span className="text-xs mt-1">Chat</span>
        </button>
        <button
          onClick={() => setActiveView('data')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${activeView === 'data'
            ? 'bg-cyan-600 text-white'
            : 'text-slate-400 hover:text-white'
            }`}
        >
          <BarChart3 size={20} />
          <span className="text-xs mt-1">Données</span>
        </button>
        <button
          onClick={() => setActiveView('news')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${activeView === 'news'
            ? 'bg-cyan-600 text-white'
            : 'text-slate-400 hover:text-white'
            }`}
        >
          <FileText size={20} />
          <span className="text-xs mt-1">News</span>
        </button>
        <button
          onClick={() => setActiveView('stat')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${activeView === 'stat'
            ? 'bg-cyan-600 text-white'
            : 'text-slate-400 hover:text-white'
            }`}>
          <BarChart3 size={20} />
          <span className="text-xs mt-1">Stats</span>
        </button>
      </div>
    </div>
  );
};

export default FooterMobile;
